module.exports = require('./countries_currencies.json')
